export const localRoomKey = (
    scope: "company" | "flow" | "card",
    flowId?: number,
    cardId?: number
) =>
    scope === "card"
        ? `card:${flowId}:${cardId}`
        : scope === "flow"
            ? `flow:${flowId}`
            : "company";